import { createSlice } from '@reduxjs/toolkit';
import ReactGA from 'react-ga';
import { post } from 'api/fetch';
import { initialize } from 'state/app';
import { createJWT } from 'auth';
import { fireSignupTrackingEvent } from 'analytics';
import history from 'routing/history';

// ================== Reducers ================== //

const slice = createSlice({
  name: 'ambassasdor/Signup',
  initialState: {
    isLoading: false,
    error: null
  },
  reducers: {
    // signup
    signupRequest: (state) => {
      state.isLoading = true;
      state.error = null;
    },
    signupSuccess: (state) => {
      state.isLoading = false;
      state.error = null;
    },
    signupFailure: (state, { payload }) => {
      state.isLoading = false;
      state.error = payload;
    },
    clearError: (state) => {
      state.error = null;
    }
  }
});

export default slice.reducer;

// ================== Actions ================== //

const { actions } = slice;

export const signup = (email, password) => async (dispatch) => {
  dispatch(actions.signupRequest());

  try {
    const response = await post('/users/register', { email, password });
    await createJWT({
      userID: response.userID,
      accessToken: response.accessToken
    });
    await dispatch(initialize(true, 'ambassador'));
    dispatch(actions.signupSuccess());
    ReactGA.event({
      category: 'Ambassador',
      action: 'Signup'
    });

    const affiliateID = localStorage.getItem('referenceID');
    fireSignupTrackingEvent(response.userID, 'email', affiliateID);

    history.push('/ambassador/registration');
  } catch (error) {
    dispatch(actions.signupFailure(error));
  }
};

export const facebookSignup = (email, password) => async (dispatch) => {
  dispatch(actions.signupRequest());

  try {
    const response = await post('/users/register', { email, password });
    await createJWT({
      userID: response.userID,
      accessToken: response.accessToken
    });
    await dispatch(initialize(true, 'ambassador'));
    dispatch(actions.signupSuccess());

    const affiliateID = localStorage.getItem('referenceID');
    fireSignupTrackingEvent(response.userID, 'facebook', affiliateID);

    history.push('/ambassador/registration');
  } catch (error) {
    dispatch(actions.signupFailure(error));
  }
};

export const clearError = () => (dispatch) => {
  dispatch(actions.clearError());
};
